// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.clampContainer---yi4oV {
  overflow: hidden;
}
div.title---_qqeu {
  display: none;
}
`, "",{"version":3,"sources":["webpack://./src/components/clamp.less"],"names":[],"mappings":"AAAA;EACE,gBAAA;AACF;AACA;EACE,aAAA;AACF","sourcesContent":[".clampContainer {\n  overflow: hidden;\n}\ndiv.title {\n  display: none;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"clampContainer": `clampContainer---yi4oV`,
	"title": `title---_qqeu`
};
export default ___CSS_LOADER_EXPORT___;
